const Simon = () => {
  const serviceName = 'Simon';

  const setTrack = (callback) => {
    if (!window.sd) {
      window.addEventListener('ResySimonLoaded', () => {
        callback();
      }, { once: true });
    } else {
      callback();
    }
  };

  const event = (name, props = {}) => {
    if (name === 'sign up') {
      const registrationData = props.userSignupData;
      registrationData.properties.language = window.preferredLanguage;
      registrationData.properties.invite = props.invite || false;
      setTrack(() => {
        window.sd.track('registration', registrationData);
      });
    }

    if (name === 'sign in') {
      setTrack(() => {
        window.sd.identify(props.userId.toString(), {
          email: props.email,
          userId: props.userId,
          properties: {
            invite: props.invite || false,
          },
        });
      });
    }

    if (name === 'click booking slot') {
      const {
        'party size': partySize,
        'lead time': leadTime,
        details,
        event: eventName,
        time,
        venue,
      } = props;

      setTrack(() => {
        window.sd.track('add_to_cart', {
          productId: details?.venueId,
          variant: time,
          quantity: partySize,
          brand: venue,
          category: details?.serviceType,
          productName: eventName || venue,
          cartItems: [{
            productId: details?.venueId,
            variant: time,
            quantity: partySize,
            brand: venue,
            category: details?.serviceType,
            productName: eventName || venue,
          }],
          properties: {
            City: details?.city,
            Date: time,
            'Lead Time': leadTime,
            Currency: details?.currency,
            language: window.preferredLanguage,
          },
        });
      });
    }
  };

  const page = () => {
    setTrack(() => {
      window.sd.track('page_view');
    });
  };

  const purchase = (token, data = {}) => {
    const {
      day,
      partySize,
      reservation,
      details,
      sourceId,
      venueId,
      venueName,
    } = data;

    setTrack(() => {
      window.sd.track('complete_transaction', {
        transactionId: token,
        revenue: details?.payment?.amounts?.total,
        cartItems: [{
          productId: venueId,
          variant: reservation?.time,
          quantity: partySize,
          brand: venueName,
          category: reservation?.serviceTypeName,
          productName: venueName,
          price: details?.payment?.amounts?.total,
        }],
        properties: {
          City: details?.venue?.location?.locality,
          Date: day,
          'Lead Time': moment(day).diff(moment().startOf('day'), 'days'),
          Currency: details?.locale?.currency,
          Source: sourceId,
          language: window.preferredLanguage,
        },
      });
    });
  };

  const setUser = (userData) => {
    setTrack(() => {
      window.sd.identify(userData.id.toString(), {
        email: userData?.em_address,
        firstName: userData?.first_name,
        lastName: userData?.last_name,
        userId: userData?.id,
        properties: {
          created: moment(userData?.date_created * 1000).toISOString(),
          phone: userData?.mobile_number,
          avatar: userData?.profile_image_url,
          bio: userData?.bio,
          language: window.preferredLanguage,
        },
      });
    });
  };

  return {
    event,
    page,
    purchase,
    serviceName,
    setUser,
  };
};

export default Simon();
